/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { Advisor } from "./advisor"
// May contain unused imports in some cases
// @ts-ignore
import type { BankPartnerV2 } from "./bank-partner-v2"
// May contain unused imports in some cases
// @ts-ignore
import type { PdfPreferences } from "./pdf-preferences"

export interface SaveNoteRequest {
  noteId: string
  structureId?: string
  comment?: string
  commentCr?: string
  statut?: SaveNoteRequestStatutEnum
  conclusion?: string
  modelEco?: SaveNoteRequestModelEcoEnum
  noteFinancier?: number
  noteGlobale?: number
  avancementBanque?: SaveNoteRequestAvancementBanqueEnum
  projectCommitteeDate?: string
  pdfPreferences?: PdfPreferences
  commentCrAnterieur?: string
  commentReason?: string
  creationExNihilo?: boolean
  commentRevelateur?: string
  commentBilanPasse?: string
  advisor?: Advisor
  bankPartnerV2?: BankPartnerV2
}

export const SaveNoteRequestStatutEnum = {
  EN_COURS: "EN_COURS",
  ABANDON: "ABANDON",
  ATTENTE_DECISION: "ATTENTE_DECISION",
  FINALISEE: "FINALISEE"
} as const

export type SaveNoteRequestStatutEnum =
  (typeof SaveNoteRequestStatutEnum)[keyof typeof SaveNoteRequestStatutEnum]
export const SaveNoteRequestModelEcoEnum = {
  MARCHAND: "MARCHAND",
  NON_MARCHAND: "NON_MARCHAND",
  HYBRIDE: "HYBRIDE"
} as const

export type SaveNoteRequestModelEcoEnum =
  (typeof SaveNoteRequestModelEcoEnum)[keyof typeof SaveNoteRequestModelEcoEnum]
export const SaveNoteRequestAvancementBanqueEnum = {
  PAS_DE_CONTACT_OU_DEBUT_DE_LA_DEMANDE_EN_COURS: "PAS_DE_CONTACT_OU_DEBUT_DE_LA_DEMANDE_EN_COURS",
  EN_ATTENTE_REPONSE_DE_LA_BANQUE: "EN_ATTENTE_REPONSE_DE_LA_BANQUE",
  ACCORD_DE_PRINCIPE_ORAL: "ACCORD_DE_PRINCIPE_ORAL",
  ACCORD_ECRIT: "ACCORD_ECRIT",
  REFUS_DE_LA_BANQUE: "REFUS_DE_LA_BANQUE",
  NON_CONCERNE: "NON_CONCERNE"
} as const

export type SaveNoteRequestAvancementBanqueEnum =
  (typeof SaveNoteRequestAvancementBanqueEnum)[keyof typeof SaveNoteRequestAvancementBanqueEnum]
